export default __webpack_public_path__ + "static/media/small.ba1dfa04.jpg";